// import $api from '../api/api';
import Vue from 'vue';
import $https from '../api/index';
import $store from '../store';
import config from '@/config/net.config';
// 时间戳
function formatDate(time) {
	var now = new Date(time);
	var year = now.getFullYear();
	var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1);
	var day = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
	var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
	var minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
	var second = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds();
	let data = {
		year,
		month,
		day,
		hour,
		minute,
		second,
		time: year + '-' + month + '-' + day + ' ' + hour + ':' + minute
	}
	return data;
}
// 获取底部友情链接
function getflist() {
	// return new Promise(function(resolve, reject) {
		console.log($api)
        var api = $api.api.footer.footer;
        $https.post({
            type: 'formData',
            api: api
        },'',
        response=>{
            console.log('fooooootttttt',response)
            $store.commit('footerlist',response.data)
            // resolve(res)
        },
        error=>{
            console.log(error)
        })
	// })
}
 function addurl(value) {
	let url = String(value);
	if (url && (url.indexOf("http") == -1 && url.indexOf("base64") == -1)) {
		url = config.baseURL + url
	}
	return url
}

// 退出登录
 function signout() {
	var api = this.$api.api.login.logout;
	var sign = localStorage.getItem("sign");
	this.$https.post(
	  {
		type: "formData",
		api: api,
	  },
	  {
		sign: sign,
	  },
	  (response) => {
		console.log("response", response);
	  },
	  (error) => {
		console.log(error);
	  }
	);
	localStorage.clear();
	this.$router.go(0);
	// logout
  }
function getflist() {
	// return new Promise(function(resolve, reject) {
		console.log($api)
        var api = $api.api.footer.footer;
        $https.post({
            type: 'formData',
            api: api
        },'',
        response=>{
            // console.log('fooooootttttt',response)
            $store.commit('footerlist',response.data)
            // resolve(res)
        },
        error=>{
            console.log(error)
        })
	// })
}
export default {
    formatDate(data) {
		return formatDate(data);
	},
    // async getflist() {
	// 	return getflist();
	// },
    // getflist() {
	// 	return getflist();
	// },
	// signout(){
	// 	return signout();
	// }
	addurl(url) {
		return addurl(url)
	},
}


export function setStorage(name, data) {
	let dataType = typeof data;
	// json对象
	if (dataType === 'object') {
		window.localStorage.setItem(name, JSON.stringify(data));
	}
	// 基础类型
	else if (['number', 'string', 'boolean'].indexOf(dataType) >= 0) {
		window.localStorage.setItem(name, data);
	}
}
// 取出本地存储内容
export function getStorage(name) {
	let data = window.localStorage.getItem(name);
	if (data) {
		try{
			return JSON.parse(data);
		}catch(e){
			//TODO handle the exception
			return data;
		}
	} else {
		return '';
	}
}
// 删除本地存储
export function removeStorage(name) {
	window.localStorage.removeItem(name);
}



// WEBPACK FOOTER //
// ./src/utils/index.js